export const itemsBaseApiPath = '/api/common/userInvites';

import {
  fetchItemsGen,
  deleteItemGen,
  getItemByIdGen,
  addItemGen,
  editItemGen
} from '../../../utils/apiHelperGenerators.js';

export const fetchItems = fetchItemsGen(itemsBaseApiPath, 'listItems');
export const deleteItem = deleteItemGen(itemsBaseApiPath);
export const getItemById = getItemByIdGen(itemsBaseApiPath);
export const addItem = addItemGen(itemsBaseApiPath);
export const editItem = editItemGen(itemsBaseApiPath, 'put');

export const resendItem = id => {
  return new Promise((resolve, reject) => {
    $http
      .post(itemsBaseApiPath + '/' + id + '/resend')
      .then(resp => {
        resolve(resp);
      })
      .catch(error => {
        console.error('resendItem error', error);
        reject(error);
      });
  });
};

export default {
  fetchItems,
  deleteItem,
  getItemById,
  addItem,
  editItem,
  resendItem
};
